import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { faClock } from '@fortawesome/pro-thin-svg-icons';

import '../styles/componentStyles/ActivityList.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/sharp-regular-svg-icons';
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { activity_list } from '../../shared/components/data';
import NumberInput from '../components/NumberInput';

function ActivityList(props) {
  const { t } = useTranslation();
  const [lines, setLines] = useState([
    {
      id: 0,
      selectedItem: '',
      duration: 0,
      db_id: null,
    },
  ]);
  const [activeId, setActiveId] = useState(null);
  const inputRefs = useRef([]);

  useEffect(() => {
    // Prevent scrolling on number input
    const handleWheel = (event) => {
      event.preventDefault();
    };

    inputRefs.current.forEach((input) => {
      if (input) {
        input.addEventListener('wheel', handleWheel);
      }
    });

    return () => {
      inputRefs.current.forEach((input) => {
        if (input) {
          input.removeEventListener('wheel', handleWheel);
        }
      });
    };
  }, [lines]);

  useEffect(() => {
    if (props.resetLines) {
      setLines([
        {
          id: 0,
          selectedItem: '',
          duration: 0,
          db_id: null,
        },
      ]);
      props.setResetLines(false);
    }
  }, [props.resetLines]);

  useEffect(() => {
    if (props.data?.[props.questionid]?.[0]?.duration) {
      const arr = [...props.data[props.questionid]];
      const modifiedArr = arr.map((el, index) => {
        const item = activity_list.find((item) => item.id === el.id);
        return {
          id: index,
          selectedItem: t(item.label),
          duration: Number(el.duration),
          db_id: el.id,
        };
      });
      setLines(modifiedArr);
    }
  }, [props.data?.[props.questionid]?.[0]?.duration]);

  useEffect(() => {
    const dbArray = [];
    lines.forEach((line) => {
      if (line.db_id && line.duration > 0) {
        dbArray.push({ id: line.db_id, duration: line.duration });
      }
    });

    props.saveResponse('data', {
      id: props.questionid,
      value: dbArray,
    });
  }, [lines]);

  const handleDeleteLine = (id) => {
    setLines(lines.filter((line) => line.id !== id));
    props.setExistingTracker(false);
  };

  const handleAddLine = () => {
    const newLineId = lines.length > 0 ? lines[lines.length - 1].id + 1 : 0;
    setLines([
      ...lines,
      {
        id: newLineId,
        selectedItem: '',
        duration: 0,
        db_id: null,
      },
    ]);
    props.setExistingTracker(false);
  };

  const handleDropDown = (id) => {
    setActiveId((prevActiveId) => (prevActiveId === id ? null : id));
  };

  const handleActivityChange = (event, lineId) => {
    props.setExistingTracker(false);
    const selectedOption = activity_list.find((item) => t(item.label) === event.target.value);

    setLines((prevLines) =>
      prevLines.map((line) => {
        if (line.id === lineId) {
          return {
            ...line,
            selectedItem: event.target.value,
            db_id: selectedOption?.id || null,
          };
        }
        return line;
      })
    );
  };

  const handleDurationChange = (value, lineId) => {
    const duration = Number(value);
    setLines((prevLines) =>
      prevLines.map((line) => {
        if (line.id === lineId) {
          return { ...line, duration };
        }
        return line;
      })
    );
  };

  return (
    <div role="group" aria-label={t('activities.list.title')}>
      {lines.map((line, index) => (
        <fieldset key={line.id} className="tracker-line no-padding fs-mask">
          <legend className="sr-only">
            {line.selectedItem || t('activities.list.select.label')}
          </legend>
          <div className="tracker-line fs-mask">
            <div className="part-line part-line-select">
              <label htmlFor={`activity-${line.id}`} className="visuallyHidden">
                {t('activities.list.select.label')}
              </label>
              <div className="tracker-select-wrapper">
                <select
                  id={`activity-${line.id}`}
                  className="tracker-select"
                  value={line.selectedItem}
                  onChange={(e) => handleActivityChange(e, line.id)}
                  aria-label={t('trackers.activityList.select.label')}
                >
                  <option value="" disabled selected aria-hidden="true">
                    {t('activities.list.select.label')}
                  </option>
                  {activity_list.map((item) => (
                    <option key={item.id} value={t(item.label)}>
                      {t(item.label)}
                    </option>
                  ))}
                </select>
                <FontAwesomeIcon icon={faChevronDown} className="select-icon" aria-hidden="true" />
              </div>
            </div>
            <div className="part-line part-line-count tracker-input-wrapper">
              <FontAwesomeIcon icon={faClock} className="tracker-icon clock" aria-hidden="true" />
              <label htmlFor={`duration-${line.id}`} className="visuallyHidden">
                {t('Duration in minutes')}
              </label>
              <NumberInput
                type="inline"
                inputName={`duration-${line.id}`}
                startValue={Number(line.duration)}
                minValue={0}
                maxValue={300}
                onSetValue={(value) => handleDurationChange(value, line.id)}
                controlsInfo={t('T070')}
                ariaLabel={t('trackers.activityList.duration.label')}
                suffix={t('T070')}
              />
            </div>
            <div className="part-line">
              <button
                type="button"
                className="tracker-remove-item"
                onClick={() => handleDeleteLine(line.id)}
                aria-label={t('activities.list.remove.label')}
              >
                <FontAwesomeIcon icon={faTimes} className="icon times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </fieldset>
      ))}
      <button
        type="button"
        className="tracker-add-line"
        onClick={handleAddLine}
        aria-label={t('T069')}
      >
        <div className="icon-cont">
          <FontAwesomeIcon icon={faPlus} className="icon plus" aria-hidden="true" />
        </div>
        <div>{t('T069')}</div>
      </button>
    </div>
  );
}

export default ActivityList;
